import * as React from 'react';
import { Overlay, SideModalContent } from '~/common/layout/Modals';
import Head from '~/common/layout/Head';


export default function(props) {
  return (
    <div>
    {/*
      <div className="side__cont">
        <a href="javascript:void(null)" className="side__logo">
          <img src="/assets/img/placeholder/logo-alt.svg" alt=""/>
        </a>

        <div className="side__nav">
          <a href="javascript:void(null)" className="side__nav__anch active">
            <span className="i i-dollar" />
            <span className="side__nav__anch__text">Payments</span>
          </a>
          <a href="javascript:void(null)" className="side__nav__anch">
            <span className="i i-buildings" />
            <span className="side__nav__anch__text">Locations</span>
          </a>
          <a href="javascript:void(null)" className="side__nav__anch">
            <span className="i i-users-fill" />
            <span className="side__nav__anch__text">Users</span>
          </a>
          <a href="javascript:void(null)" className="side__nav__anch">
            <span className="i i-cog" />
            <span className="side__nav__anch__text">Settings</span>
          </a>
        </div>

        <div className="side__user">
          <div className="side__user__img"><img src="/assets/img/placeholder/user.jpg" alt=""/></div>
        </div>
      </div>

      <Head headTitle="Codes">
        <div className="input--search">
          <a href="javascript:void(null)" className="input__icon input--search__btn">
            <span className="i i-search" />
          </a>
          <input type="text" placeholder="Search Codes"/>
        </div>

        <a href="javascript:void(null)" className="btn btn--secn btn--lg">Create Code</a>
      </Head>

      <div className="app__view">

        <div className="button-wrapper">
          <a href="javascript:void(null)" className="btn btn--prim btn--lg">Primary Button</a>
          <a href="javascript:void(null)" className="btn btn--prim btn--md">Primary Button</a>
          <a href="javascript:void(null)" className="btn btn--prim btn--sm">Primary Button</a>
          <a href="javascript:void(null)" className="btn btn--secn btn--lg">Secondary Button</a>
          <a href="javascript:void(null)" className="btn btn--secn btn--md">Secondary Button</a>
          <a href="javascript:void(null)" className="btn btn--secn btn--sm">Secondary Button</a>
          <a href="javascript:void(null)" className="btn btn--outl btn--lg">Outline Button</a>
          <a href="javascript:void(null)" className="btn btn--outl btn--md">Outline Button</a>
          <a href="javascript:void(null)" className="btn btn--outl btn--sm">Outline Button</a>
          <a href="javascript:void(null)" className="btn btn--tert btn--lg">Button Tertiary</a>
          <a href="javascript:void(null)" className="btn btn--tert btn--md">Button Tertiary</a>
          <a href="javascript:void(null)" className="btn btn--tert btn--sm">Button Tertiary</a>
          <a href="javascript:void(null)" className="btn btn--prim btn--lg">Primary Button With Icon <span className="i i-check" /></a>
          <a href="javascript:void(null)" className="btn btn--prim btn--md">Primary Button With Icon <span className="i i-check" /></a>
          <a href="javascript:void(null)" className="btn btn--outl btn--sm">Outline Button With Icon <span className="i i-check" /></a>
          <a href="javascript:void(null)" className="btn btn--text btn--sm">Outline Button With Icon <span className="i i-check" /></a>

        </div>
      </div>

      <div className="ol__cont dn">

        <div className="modal modal--pop modal--invoice">
          <div className="invoice__head">
            <span className="invoice__head__logo">
              <img src="/assets/img/placeholder/logo-inline.svg" alt=""/>
            </span>
            <span className="invoice__head__text">Receipt</span>
          </div>

          <div className="col__cont modal--invoice__content">
            <div className="col__row col--invoice">
              <div className="col col--3">
                <div className="grid__inn">
                  <img className="grid__logo" src="assets/img/placeholder/capstone.png" alt="" />
                  <div className="grid__row">
                    <span className="grid__label">EIN:</span>
                    <span className="grid__value">39-5928539</span>
                  </div>
                </div>
              </div>
              <div className="col col--3">
                <div className="grid__inn">
                  <span className="grid__label">Amount Due</span>
                  <span className="grid__amount">$145.00</span>
                  <span className="btn btn--sm btn--prim btn--tag">Paid in full</span>
                </div>
              </div>
              <div className="col col--3">
                <div className="grid__inn">
                  <div className="grid__inline">
                    <span className="grid__label">Date</span>
                    <span className="grid__value">1/10/2019</span>
                  </div>
                  <div className="grid__inline">
                    <span className="grid__label">Receipt #</span>
                    <span className="grid__value">22042</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col__row">
              <div className="col col--6">
                <div className="grid__inn--fw">

                  <div className="grid__fw">
                    <span className="grid__label">location</span>
                    <span className="grid__value">Norcross, GA</span>
                  </div>

                  <div className="grid__inn">
                    <span className="grid__label">Items</span>

                    <div className="grid__row__inline">
                      <span className="grid__value">Pallets</span>
                      <span className="grid__value">$15.66</span>
                    </div>
                    <div className="grid__row__inline">
                      <span className="grid__value">Pallets</span>
                      <span className="grid__value">$15.66</span>
                    </div>
                    <div className="grid__row__inline">
                      <span className="grid__value">Pallets</span>
                      <span className="grid__value">$15.66</span>
                    </div>
                    <div className="grid__row__inline">
                      <span className="grid__value">Pallets</span>
                      <span className="grid__value">$15.66</span>
                    </div>
                    <div className="grid__row__inline">
                      <span className="grid__value">Pallets</span>
                      <span className="grid__value">$15.66</span>
                    </div>
                    <div className="grid__row__inline">
                      <span className="grid__value">Pallets</span>
                      <span className="grid__value">$15.66</span>
                    </div>
                    <div className="grid__row__inline">
                      <span className="grid__value">Pallets</span>
                      <span className="grid__value">$15.66</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col col--6">
                <div className="grid__inn">
                  <div className="grid__inline">
                    <span className="grid__label">PO #</span>
                    <span className="grid__value">389467</span>
                    <span className="grid__value">389467</span>
                    <span className="grid__value">389467</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col__row modal--invoice__foot">
            <div className="modal--invoice__btns">
              <a href="javascript:void(null)" className="btn btn--tert alt btn--md">Download</a>
              <a href="javascript:void(null)" className="btn btn--tert alt btn--md">Print</a>
              <a href="javascript:void(null)" className="btn btn--tert alt btn--md">Email</a>
              <a href="javascript:void(null)" className="btn btn--tert alt btn--md">Text</a>
            </div>

            <div className="input input--outl">
              <label className="input__label input__label--inline">Link:</label>
              <input placeholder="Click to copy..." value="relay.link/4f3321" />
            </div>
          </div>
        </div>
      </div>


      <div className="dn">
        <Overlay>
          <Head headTitle="New Payment">
            <a href="javascript:void(null)" className="btn btn--prim btn--md">Edit</a>
          </Head>

          <SideModalContent>
            <div className="form__cont">
              <div className="input input--bubble input--step input--sign">
                <span className="input__step">1.</span>
                <span className="input--sign__sign">$</span>
                <input type="text" placeholder="Enter Payment Amount"/>
                <label className="input__label">Payment Amount</label>
              </div>
              <div className="input input--bubble input--step">
                <span className="input__step">2.</span>
                <input type="text" placeholder="Enter Payment Amount"/>
                <label className="input__label">Payment Amount</label>
              </div>
              <div className="input input--bubble input--step input--active">
                <span className="input__step">3.</span>
                <input type="text" placeholder="Enter Payment Amount" value="Kroger Stores" />
                <label className="input__label">Restriction</label>
              </div>
              <div className="input input--bubble input--step drop__cont">
                <span className="input__step">4.</span>
                <input type="text" placeholder="Enter Payment Amount"/>
                <label className="input__label">Payment Amount</label>
                <div className="drop__down">
                  <div className="drop__inn">
                    <ul>
                      <li><a href="javascript:void(null)">lorem</a></li>
                      <li><a href="javascript:void(null)">lorem</a></li>
                      <li><a href="javascript:void(null)">lorem</a></li>
                      <li><a href="javascript:void(null)">lorem</a></li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="input input--bubble input--step">
                <span className="input__step">
                  <span className="i i-check" />
                </span>
                <input type="text" placeholder="Enter Payment Amount"/>
                <label className="input__label">Payment Amount</label>
              </div>

              <div className="input input--bubble input--step input--valid">
                <input type="text" placeholder="Enter Payment Amount"/>
                <label className="input__label">Payment Amount</label>
                <span className="input__step">
                  <span className="i i-check" />
                </span>
              </div>
            </div>
          </SideModalContent>
        </Overlay>

      </div>
      */}

        <div className="app--md">
          <div className="m__ol">
            <div className="m__head">
              <span className="m__head__titl m__ol__titl">
                Payment Detail
              </span>
              <div className="m__head__right">
                <a href="javascript:void(null)" className="m__head__anch">
                  <span className="i i-close-alt" />
                </a>
              </div>
            </div>
            <div className="m__body app--md__box">
              <div className="col__cont">
                <div className="col__row">
                  <div className="col col--half">
                    <div className="m__body__info__block">
                      <div className="m__body__lbl">Amount</div>
                      <div className="m__body__lbl__info">$45.50</div>
                    </div>
                    <div className="m__body__info__block">
                      <div className="m__body__lbl">Check number</div>
                      <div className="m__body__lbl__info">32432413</div>
                    </div>
                    <div className="m__body__info__block">
                      <div className="m__body__lbl">D.L. NUMBER</div>
                      <div className="m__body__lbl__info">92030132</div>
                    </div>
                    <div className="m__body__info__block">
                      <div className="m__body__lbl">PROCESSED</div>
                      <div className="m__body__lbl__info">June 16, 2018 </div>
                    </div>
                  </div>
                  <div className="col col--half">
                    <div className="m__body__info__block">
                      <div className="m__body__lbl">PAYMENT TYPE</div>
                      <div className="m__body__lbl__info">EFS</div>
                    </div>
                    <div className="m__body__info__block">
                      <div className="m__body__lbl">EXPRESS CODE</div>
                      <div className="m__body__lbl__info">n/a</div>
                    </div>
                    <div className="m__body__info__block">
                      <div className="m__body__lbl">D.L. STATE</div>
                      <div className="m__body__lbl__info">Georgia</div>
                    </div>
                    <div className="m__body__info__block">
                      <div className="m__body__lbl">CONFIRMATION</div>
                      <div className="m__body__lbl__info">9273</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="m__foot">

              <div className="m__foot__btns">
                <a href="javascript:void(null)" className="btn btn--outl--lite btn--lgry btn--xlg ">
                  <span className="btn__i">
                    <span className="i i-msg" />
                  </span>
                  Send receipt as a text
                </a>
                <a href="javascript:void(null)" className="btn btn--outl--lite btn--lgry btn--xlg ">
                  <span className="btn__i">
                    <span className="i i-mail" />
                  </span>
                  Send receipt as an email
                </a>
              </div>
            </div>
          </div>


          <div className="m__head app--md__box">
            <div className="m__head__left">
              <a href="javascript:void(null)" className="m__head__anch">
                <span className="i i-arw-l" />
              </a>
            </div>
            <div className="m__head__cent">
              <a href="javascript:void(null)" className="m__head__logo dn">
                <span className="i i-logo" />
              </a>
              <span className="m__head__titl">
                $45.50(EPS)
              </span>
            </div>
            <div className="m__head__right">
              <a href="javascript:void(null)" className="m__head__anch">
                <span className="i i-search" />
              </a>
            </div>
          </div>

          <div className="m__body app--md__box">
            <div className="m__body__titl">New Payment</div>
            <div className="m__body__i lg"><span className="i i-truck" /></div>
            <div className="m__body__titl--lg">Good to go!</div>

            <div className="form__cont">
              <div className="input input--sm">
                <input placeholder="Enter express code" type="text" />
                <label className="input__lbl">Express Code</label>

                <a href="javascript:void(null)" className="input__help">Where can i find this?</a>
              </div>
              <div className="input input--sm input--active">
                <input placeholder="Enter express code" type="text" value="839305J921"/>
                <label className="input__lbl">Express Code</label>

                <a href="javascript:void(null)" className="input__help">Where can i find this?</a>
              </div>
            </div>
            <p className="m__body__info">Process a transaction in 60 seconds. <br/>
            <a href="javascript:void(null)" className="m__body__anch">Need assistance?</a></p>
            <div className="form--rows">
              <div className="m__body__lbl">Select Payment Type</div>
              <div className="m__body__tags">
                <a href="javascript:void(null)" className="btn btn--md btn--outl--lgry btn--tag">Comchek</a>
                <a href="javascript:void(null)" className="btn btn--md btn--outl--lgry btn--tag">EFS</a>
                <a href="javascript:void(null)" className="btn btn--md btn--outl--lgry btn--tag">Comchek</a>
                <a href="javascript:void(null)" className="btn btn--md btn--outl--lgry btn--tag btn--tag--active">Tchek</a>
                <a href="javascript:void(null)" className="btn btn--md btn--outl--lgry btn--tag">Comchek</a>
                <a href="javascript:void(null)" className="btn btn--md btn--outl--lgry btn--tag">Comchek</a>
              </div>
            </div>
            <p className="m__body__info">Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum deserunt fugiat deleniti dolores, inventore sit autem exercitationem quos aperiam eos, neque maiores reprehenderit, praesentium quidem consectetur vitae nulla quasi obcaecati!</p>
          </div>

          <div className="m__foot app--md__box">
            <div className="m__foot__btns">

              <div className="color--prim">
                <a href="javascript:void(null)" className="btn btn--outl--lite btn--xlg dn">
                  <span className="btn__i">
                    <span className="i i-mail" />
                  </span>
                  Complete fields to contniue
                </a>
              </div>
              <a href="javascript:void(null)" className="btn btn--outl btn--xlg dn">Complete fields to contniue</a>
              <a href="javascript:void(null)" className="btn btn--outl btn--xlg dn">
                <span className="btn__i">
                  <span className="i i-mail" />
                </span>
                Send Recipet as Email
              </a>
              <a href="javascript:void(null)" className="btn btn--lgry btn--xlg ">
                <span className="btn__i">
                  <span className="i i-msg" />
                </span>
                Send as a text
              </a>
              <a href="javascript:void(null)" className="btn btn--prim btn--xlg dn">Complete fields to contniue</a>
            </div>
          </div>
        </div>
        {/*
            // Receiver header with bars
        <div className="head--data__content">
          <div className="blocks__cont blocks--data">
            <div className="blocks__box dn">
              <span className="blocks__lbl">Total Processed</span>
              <span className="blocks__value blocks__value--balance"><span class="blocks__value__sign">$</span>8,873.85</span>
            </div>
            <div className="blocks__box">
              <span className="blocks__lbl">Top Locations</span>
              <ul className="blocks__list">

                <li className="blocks__list__item">
                  <div className="blocks__list__item__inn">
                    <span className="blocks__list__info">Brooklyn, NY</span>
                    <span className="blocks__bar">
                      <span className="blocks__bar__line" style={{width: "98%"}} />
                      <span className="blocks__bar__text">98</span>
                    </span>
                  </div>
                </li>
                <li className="blocks__list__item">
                  <div className="blocks__list__item__inn">
                    <span className="blocks__list__info">Lomira, WI</span>
                    <span className="blocks__bar">
                      <span className="blocks__bar__line" style={{width: "73%"}} />
                      <span className="blocks__bar__text">73</span>
                    </span>
                  </div>
                </li>
                <li className="blocks__list__item">
                  <div className="blocks__list__item__inn">
                    <span className="blocks__list__info">Kennesaw, GA</span>
                    <span className="blocks__bar">
                      <span className="blocks__bar__line" style={{width: "53%"}} />
                      <span className="blocks__bar__text">53</span>
                    </span>
                  </div>
                </li>
                <li className="blocks__list__item">
                  <div className="blocks__list__item__inn">
                    <span className="blocks__list__info">Philadelphia, PA</span>
                    <span className="blocks__bar">
                      <span className="blocks__bar__line" style={{width: "50%"}} />
                      <span className="blocks__bar__text">50</span>
                    </span>
                  </div>
                </li>
                <li className="blocks__list__item">
                  <div className="blocks__list__item__inn">
                    <span className="blocks__list__info">Macon, GA</span>
                    <span className="blocks__bar">
                      <span className="blocks__bar__line" style={{width: "49%"}} />
                      <span className="blocks__bar__text">49</span>
                    </span>
                  </div>
                </li>

              </ul>
              <a href="" className="blocks__box__more">+3 more</a>
            </div>
          </div>
        </div>
        */}
    </div>
  );
};
